import DjangoRest from './DjanoBaseRest'

const resource = '/member'

export default {
    Login (credentials) {
        return DjangoRest.post(`${resource}/login/`, credentials)
    },
    Logout () {
        return DjangoRest.post(`${resource}/logout/`)
    },
    IsSessionActive () {
        return DjangoRest.get(`${resource}/is_active/`)
    },
    FetchDetails () {
        return DjangoRest.post(`${resource}/details/`)
    },
    ResetPassword (payload) {
        return DjangoRest.post(`${resource}/reset_password/`, payload)
    },
}
